import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { GeneralService } from '../general.service';
import {TranslateService} from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Session } from 'protractor';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-loadexam',
  templateUrl: './loadexam.component.html',
  styleUrls: ['./loadexam.component.scss']
})
export class LoadexamComponent implements OnInit {

  public logo: any;
  public languageSelected = "en";
  public examMinutes: any;
  public examDate:any;

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService,
    private sanitizer: DomSanitizer
  ) {
    this.logo = "../../assets/ecitb.jpg";
    
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }

    if (dataSvc.currentUser.ScheduleCandidate == null || dataSvc.currentUser.Exams.length == 0){
      var enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
      generalSvc.logoutUser(enetsecure);
    }

    this.examMinutes = this.formatAssessmentTime(dataSvc.currentExam.Session.AssessmentTime);
    this.examDate = this.formatExamDate(dataSvc.currentUser.Schedule.StartDate);

    //if (dataSvc.currentExamIndex == -1)
      //generalSvc.loginUser();

    if (dataSvc.currentExam.Session.TimeTakenInSeconds > 0)
      this.resumeExam();
    
    if (dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == null || dataSvc.currentUser.Exams[dataSvc.currentExamIndex].Session.AssessmentFrontPageText == "")
      this.startExam();

    if(dataSvc.currentUser.Media.length > 0){
      let mediaSrc = dataSvc.currentUser.Media[0].Data
      if(!mediaSrc.startsWith('data:image'))
        mediaSrc = 'data:image/png;base64, ' + mediaSrc;

      this.logo = sanitizer.bypassSecurityTrustUrl(mediaSrc);
    }

    this.dataSvc.currentExam.Session.AssessmentFrontPageText = this.dataSvc.currentExam.Session.AssessmentFrontPageText.replaceAll("&nbsp;", " ");
  }

  ngOnInit() {
  }

  private formatAssessmentTime(totalMinutes: number): string {
    if (totalMinutes == null || isNaN(totalMinutes)) {
      return "";
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const parts = [];

    if (hours > 0) {
      parts.push(hours + " " + (hours === 1 ? "hour" : "hours"));
    }

    if (minutes > 0 || hours === 0) {
      parts.push(minutes + " mins");
    }

    return parts.join(" ");
  }

  private formatExamDate(startDate: string): string {
    if (startDate == null || startDate === "") {
      return "";
    }

    const date = new Date(startDate);
    if (isNaN(date.getTime())) {
      return "";
    }

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate().toString().padStart(2, "0");

    return day + " " + months[date.getMonth()] + " " + date.getFullYear();
  }

  

  startExam() {
    this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].StatusText = "Started";
    var sessionId = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.SessionId;
    if(sessionId !== null && sessionId !== undefined && sessionId > 0){
      this.dataSvc.updateSessionStatus(sessionId, 3);
      this.dataSvc.updateScheduleCandidateStatus(sessionId, 3);
    }
    this.initiateTimer();
    this.resumeExam();
  }

  initiateTimer(){
    var timerMins = 0;
    var questions = this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Questions;
    for(var q = 0; q < questions.length; q++){
      var question = questions[q].Question;
      if(question != null){
        var qTime = question.QuestionTime;
        if(qTime !== null){
          timerMins += qTime;
        }
      }
    }

    var adaptedTimeSeconds = 0;
    var scheduleCandidate = this.dataSvc.currentUser.ScheduleCandidate;
    if(scheduleCandidate != null){
      if(scheduleCandidate.ExtraTime != null && scheduleCandidate.ExtraTime > 0){
        adaptedTimeSeconds = Number(scheduleCandidate.ExtraTime) || 0;
      }
    }

    var timerSeconds = (timerMins * 60) + adaptedTimeSeconds;
    
     var startTime = new Date();
     var endTime = new Date();
     endTime.setSeconds(endTime.getSeconds() + timerSeconds);
     endTime = new Date(endTime);

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == null 
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.TimeStarted = startTime;
    }

    if(this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == null
      || this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime == ""){
        this.dataSvc.currentUser.Exams[this.dataSvc.currentExamIndex].Session.ExpectedEndTime = endTime;
    }    
  }

  changeLangauge(language) {
    localStorage.setItem("userslanguage", language.toString());
    this.translate.setDefaultLang(language.toString());
    this.translate.use(language.toString());
    this.languageSelected = language.toString();  
  }

  resumeExam() {
    this.generalSvc.launchExamQuestions();
    this.dataSvc.startSyncMethods();
  }

  logout(){
    const enetsecure = this.dataSvc.enetsecureMobile ? "enetsecuremobile=1" : this.dataSvc.enetsecureWeb ? "enetsecureweb=1" : "";
    this.generalSvc.logoutUser(enetsecure);
  }
}
